import GameService from "src/services/GameService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {
	SAVE: "game/save",
	STORE: "game/store",
	UPDATE: "game/update",
	DUPLICATE: "game/duplicate",
	DELETE: "game/delete",
	COUNT: "game/count",
	SHOW_IN_TOOLBAR: "game/showInToolbar",
	IS_CREATE_GAME_SCREEN: "game/isCreateGameScreen",
	DISPLAY: "game/display",
	DISPLAY_VIEW: "game/display-view",
	FITLER_SEARCH: "game/filter-search",
	FILTER_TYPE: "game/filter-type"
};

export const params = {
	name: "",
	company_id: "",
	type_id: "",
	min_questions: 0,
	public: true,
	tags: [],
	newTags: [],
	share: false
};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.game,
@property  {array}  modules.games
@property  {array}  modules.gamesCount
 **/

const module = {
	state: {
		showInToolbar: false,
		isCreateGameScreen: false,
		display: 3,
		displayView: "desktop",
		filterSearch: "",
		filterType: null,
	},
	mutations: {
		[types.SHOW_IN_TOOLBAR](state, canShow) {
			state.showInToolbar = canShow;
		},
		[types.IS_CREATE_GAME_SCREEN](state, isCreateGameScreen) {
			state.isCreateGameScreen = isCreateGameScreen;
		},
		[types.DUPLICATE](state, game) {
			state.games.unshift(game);
			state.gamesCount++;
		},
		[types.DISPLAY](state, display){
			state.display = display;
		},
		[types.DISPLAY_VIEW](state, displayView){
			state.displayView = displayView;
		},
		[types.FITLER_SEARCH](state, filterSearch) {
			state.filterSearch = filterSearch;
		},
		[types.FILTER_TYPE](state, filterType) {
			state.filterType = filterType;
		}
	},
	getters: {
		gamesCount(state) {
			return state.gamesCount;
		},
		games(state) {
			return state.games;
		},
		game(state) {
			return state.game;
		},
		showInToolbar(state) {
			return state.showInToolbar;
		},
		isCreateGameScreen(state) {
			return state.isCreateGameScreen;
		},
		gameDisplay(state){
			return state.display;
		},
		displayView(state){
			return state.displayView;
		},
		filterSearch(state) {
			return state.filterSearch;
		},
		filterType(state) {
			return state.filterType;
		}
	},
	actions: {
		async [types.DUPLICATE](context, duplicate) {
			const game = await GameService.duplicate(duplicate.id, duplicate);
			if (!duplicate.deleted_at) {
				context.commit(types.DUPLICATE, game);
			}
			return game;
		},
		async [types.STORE](context, form) {
			const game = await GameService.create(form);
			context.commit(types.STORE, game);
			context.dispatch(types.COUNT);
			return game;
		},
		async [types.UPDATE](context, game) {
			const newGame = await GameService.update(game);
			context.commit(types.UPDATE, newGame);
			context.dispatch(types.COUNT);
			return newGame;
		}
	},
	types: types
};
export default ModuleCreator("game", GameService, module, types, params);
